<h1 *ngIf="currentDataService.Config">{{currentDataService.Config.name}}</h1>
<div *ngIf="currentDataService.Config" class="schemaBlockWrapper">
    <div  class="dbSchemeImage">
        <img [src]="'assets/' + currentDataService.Config.schemaPic">    
    </div>
    <div>
        <h3 class="actionsHeader">Actions:</h3>
        <ul>
            <li *ngFor="let action of currentDataService.Config.actionsDescription">{{action}}</li>
        </ul>
    </div>
</div>

<mat-form-field style="width: 75%; scroll-behavior: auto;">
<textarea matInput
cdkTextareaAutosize
[(ngModel)]="sqlText"
 placeholder="Enter SQL query"></textarea>
</mat-form-field>
<button mat-icon-button (click)="showSolutionSQL()">
    <mat-icon matTooltip="See solution">visibility</mat-icon>
</button>
 <br/>
<button mat-flat-button mat-button color="primary"
matTooltip="Run SQL and see results"
(click)="executeSQL()">Run SQL</button>
<br/>
<font color="red"
*ngIf="currentDataService.resultError"
>
<br>
{{currentDataService.resultError}}
</font>
<br>

<app-table-view 
    *ngIf="currentDataService.Data"
    [content]="currentDataService.Data"></app-table-view>
<app-gsi-solution [SolutionRequested]="solutionRequested"></app-gsi-solution>